import { useState, FormEvent } from "react";
import Layout from "@/components/feature/Layout";
import Breadcrumb from "@/components/feature/Breadcrumb";

export default function Contact() {
  const [status, setStatus] = useState<"idle" | "loading" | "success" | "error">("idle");
  const [error, setError] = useState("");

  const onSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const formEl = e.currentTarget;
    const data = new FormData(formEl);
    const hp = String(data.get("website_alt") || "").trim();
    if (hp) {
      setStatus("success");
      formEl.reset();
      return;
    }
    data.delete("website_alt");
    setStatus("loading");
    setError("");
    try {
      const body = new URLSearchParams();
      data.forEach((v, k) => body.append(k, String(v)));
      const res = await fetch("https://readdy.ai/api/form/dalpnb3rcjjiq9ekhkj0", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: body.toString(),
      });
      const text = await res.text();
      let parsed: any = null;
      try { parsed = JSON.parse(text); } catch { parsed = null; }
      const msg = parsed?.meta?.message || parsed?.meta?.detail || text || "";
      if (res.ok && parsed?.code === "OK" && !String(msg).toLowerCase().includes("spam")) {
        setStatus("success");
        formEl.reset();
      } else {
        setStatus("error");
        setError(msg || "Something went wrong. Please try again.");
      }
    } catch {
      setStatus("error");
      setError("Network error. Please try again.");
    }
  };

  return (
    <Layout>
      <section>
        <div className="shell pt-24 pb-16">
          <Breadcrumb items={[{ label: "Contact" }]} />
          <h1 className="mt-8 font-display text-5xl md:text-6xl text-black">Contact</h1>
          <p className="mt-4 text-graphite max-w-xl leading-relaxed">
            Our client care team is available Monday through Friday and responds within one business day.
          </p>
        </div>

        <div className="shell pb-24 grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-4 space-y-6 text-[14px] text-graphite leading-[1.9]">
            <div>
              <p className="eyebrow mb-2 text-black">Atelier</p>
              <p>Hopland 34<br />2000 Antwerp, Belgium</p>
            </div>
            <div>
              <p className="eyebrow mb-2 text-black">Client Care</p>
              <p>care@aurelin.com<br />+32 3 210 44 90</p>
            </div>
            <div>
              <p className="eyebrow mb-2 text-black">Hours</p>
              <p>Monday – Friday<br />10:00 – 18:00 CET</p>
            </div>
          </div>

          <div className="md:col-span-7 md:col-start-6">
            {status === "success" ? (
              <div className="border border-black/10 p-10 text-center">
                <p className="eyebrow mb-3">Received</p>
                <h2 className="font-display text-3xl text-black">Thank you.</h2>
                <p className="mt-4 text-graphite text-[15px] leading-relaxed">
                  Your message has been received. Our client care team will respond within one business day.
                </p>
              </div>
            ) : (
              <form
                id="contact-form"
                data-readdy-form
                onSubmit={onSubmit}
                className="space-y-5"
              >
                <div>
                  <label className="eyebrow block mb-2">Name</label>
                  <input
                    type="text"
                    name="name"
                    required
                    className="field w-full"
                  />
                </div>
                <div>
                  <label className="eyebrow block mb-2">Email</label>
                  <input
                    type="email"
                    name="email"
                    required
                    className="field w-full"
                  />
                </div>
                <div>
                  <label className="eyebrow block mb-2">Order Number <span className="text-graphite/70 normal-case tracking-normal">— optional</span></label>
                  <input
                    type="text"
                    name="order_number"
                    className="field w-full"
                  />
                </div>
                <div>
                  <label className="eyebrow block mb-2">Message</label>
                  <textarea
                    name="message"
                    required
                    rows={6}
                    maxLength={500}
                    className="field w-full resize-none"
                  />
                </div>
                <input
                  type="text"
                  name="website_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                  className="hp-field"
                />
                <div className="pt-2">
                  <button
                    type="submit"
                    disabled={status === "loading"}
                    className="btn btn-primary"
                  >
                    {status === "loading" ? "Sending…" : "Submit"}
                  </button>
                </div>
                {status === "error" && <p className="text-sm text-red-600">{error}</p>}
              </form>
            )}
          </div>
        </div>
      </section>
    </Layout>
  );
}